export interface SearchControlsInput {
  /** キーワード欄に今入っている文字。 */
  keyword: string | null | undefined;
  /** キーワード以外の絞り込み（プルダウン等）が画面にあるか。false はクリアボタンを置かない。 */
  hasFilterControls?: boolean;
  /**
   * キーワード以外の絞り込みが選ばれているか。
   * 未指定は従来どおりクリアボタンを常に出す。
   */
  hasActiveFilters?: boolean;
}

/**
 * - visible: 出す
 * - reserved: 隠すが幅は確保する（出し入れでキーワード欄の幅を変えない）
 * - none: 置かない（プルダウンの無い画面）
 */
export type ClearButtonMode = "visible" | "reserved" | "none";

export interface SearchControls {
  /** キーワード欄の ×（キーワードだけを消す）。 */
  showKeywordClear: boolean;
  /** クリアボタン（キーワードと絞り込みをすべて戻す）。 */
  clearButton: ClearButtonMode;
}

/**
 * 初期値が空でない切替（会計年度など）を、絞り込みの選択とみなすか。
 * 空と初期値は未選択。初期値以外が入っているときだけ選択。
 */
export const isChangedFromDefault = (
  value: string | null | undefined,
  defaultValue: string,
): boolean => {
  const current = value ?? "";
  return current !== "" && current !== defaultValue;
};

const resolveClearButton = (
  hasFilterControls: boolean,
  hasActiveFilters: boolean | undefined,
): ClearButtonMode => {
  if (!hasFilterControls) return "none";
  if (hasActiveFilters === undefined || hasActiveFilters) return "visible";
  return "reserved";
};

export const resolveSearchControls = ({
  keyword,
  hasFilterControls = true,
  hasActiveFilters,
}: SearchControlsInput): SearchControls => ({
  showKeywordClear: (keyword ?? "").length > 0,
  clearButton: resolveClearButton(hasFilterControls, hasActiveFilters),
});
